import { useCallback, useEffect, useState } from 'react';

export const AUTH_EMAIL_COOLDOWN_SECONDS = 60;

export default function useAuthEmailCooldown() {
  const [secondsRemaining, setSecondsRemaining] = useState(0);

  useEffect(() => {
    if (secondsRemaining <= 0) return undefined;

    const timer = window.setTimeout(() => {
      setSecondsRemaining((current) => Math.max(0, current - 1));
    }, 1000);

    return () => window.clearTimeout(timer);
  }, [secondsRemaining]);

  const startCooldown = useCallback(() => {
    setSecondsRemaining(AUTH_EMAIL_COOLDOWN_SECONDS);
  }, []);

  return { secondsRemaining, startCooldown };
}
